module.exports = __webpack_public_path__ + "static/media/employement-bg.5c27bb1e.png";